module.exports = __webpack_public_path__ + "static/media/IMG_8041.bc57efea.jpg";